import { N600, N800, P400 } from '@atlaskit/theme/colors';
import styled from '@emotion/styled';
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
// import { useResendEmailData } from '../../../../hook';
// import { Environment } from '@atlassiansox/bxpkit-core';
// import { getCheckEmailAnalyticsService } from '../../../../service/check-email-page';

// import { ResendEmailButton } from '../../../legacy/view/check-email-page/components';
import { useAppSelector } from '../../../../redux';
import { useDevopsState } from '../../hook';
import { messages } from '../../messages';
import { fontCharlieDisplay, fontCharlieText } from '../styled';

export function ResendEmailDevopsPage() {
  const hideHeader = true;
  const { /*productKeys,*/ devopsImageUrls } = useDevopsState();

  const email = useAppSelector(
    ({ sharedFormData: { resendEmailAddress } }) => resendEmailAddress
  );
  // const isStaging = Environment.getEnvironment() === 'staging';
  // const wacEnvUrl = Environment.getWacIntegrationUrl();
  // const productKeysMap = productKeys.map((p) => (p.product ? p.product : ''));
  // const baseUrl = isStaging
  //   ? `${wacEnvUrl}/apis/stg/hamlet`
  //   : `${wacEnvUrl}/hamlet`;

  // const checkEmailAnalyticsService = getCheckEmailAnalyticsService({
  //   baseUrl,
  //   googleAnalyticsId: 'UA-6032469-23',
  //   productKeys: productKeysMap
  // });
  // const [{ email = '' }, {}] = useResendEmailData();
  const DevopsResendPage = (
    <Devopsgroup>
      <DevopsImageWrapper>
        <img src={devopsImageUrls?.envelopeN2N} />
      </DevopsImageWrapper>
      <DevopsText>
        <FormattedHTMLMessage
          {...messages.devopsEmailSent}
          values={{ email }}
        />
      </DevopsText>
      <LineDivide></LineDivide>
      <DevopsText className="break">
        <FormattedHTMLMessage {...messages.devopsNoResendNoEmail} />
      </DevopsText>
      {/* <DevopsButtonGroup>
        <ResendEmailButton
          baseUrl={baseUrl}
          checkEmailAnalyticsService={checkEmailAnalyticsService}
        />
      </DevopsButtonGroup> */}
    </Devopsgroup>
  );

  return (
    <Wrapper>
      <DevopsHeader>
        {!hideHeader && <FormattedMessage {...messages.devopsHeader} />}
        <FormattedMessage {...messages.devopsSubHeader} />
      </DevopsHeader>

      {DevopsResendPage}
    </Wrapper>
  );
}
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0px;
  align-items: center;
  font-family: ${fontCharlieText};
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #091e42;
  letter-spacing: 0.05em;

  a {
    text-decoration: none !important;
  }

  a:hover {
    text-decoration: underline !important;
  }

  svg {
    margin-bottom: 0 !important;
  }
`;
export const LineDivide = styled.div`
  max-width: 390px;
  border: 1px solid ${P400};
  margin: 17px 0px 17px 0px;
  width: 100%;
`;
export const DevopsText = styled.p`
  font-family: ${fontCharlieDisplay};
  margin-top: 0px;
  font-size: 20px;
  color: ${N800};
  line-height: 28px;
  letter-spacing: 0.3px;
  max-width: 390px;
  text-align: center;
  div {
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: inherit;

    @media only screen and (max-width: 769px) {
      display: block;
    }
  }

  &.break {
    font-size: 14px !important;
    line-height: 18px;
    text-align: center;
    @media only screen and (max-width: 769px) {
      padding-bottom: 10px;
    }
  }
`;

export const DevopsImageWrapper = styled.div`
  width: 225px;
  padding-bottom: 25px;
  display: flex;
  justify-content: center;
  margin-top: 26px;

  @media only screen and (max-width: 769px) {
    margin-top: 16px;
    padding-bottom: 20px;
  }
`;
export const DevopsHeader = styled.span`
  font-size: 32px;
  line-height: 40px;
  font-family: ${fontCharlieDisplay};
  color: ${N600};
  font-weight: 400;
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;

  @media only screen and (max-width: 769px) {
    font-size: 24px;
    line-height: 28px;
    padding-bottom: 16px;
  }

  span:first-child {
    padding-bottom: 14px;
  }

  @media only screen and (max-width: 424px) {
    max-width: 266px;
  }
`;
export const Devopsgroup = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
  align-items: center;
  text-align: center;
  max-width: 422px;

  @media only screen and (max-width: 769px) {
    max-width: 300px;
  }
`;
// export const DevopsButtonGroup = styled.div`
//   margin-top: 20px;
//   margin-bottom: 20px;
//   button {
//     border-radius: 3px;
//     padding: 6px 12px;
//   }
//   span {
//     font-size: 14px;
//     line-height: 20px;
//     font-family: ${fontCharlieText};
//   }
// `;
